export default __webpack_public_path__ + "static/media/JohnDonovan.5527b437.jpg";